var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit01 = function SvgEdit01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 26.02,
    y1: 183.01,
    x2: 171.15,
    y2: 28.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 25.21,
    y1: 182.25,
    x2: 170.34,
    y2: 27.52,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M184.59,125.38c-2.75,0-4.98,2.23-4.98,4.98v44.23c-.01,8.25-6.69,14.94-14.94,14.94H24.9c-8.25,0-14.93-6.69-14.94-14.94V44.79c.01-8.25,6.69-14.93,14.94-14.94h44.23c2.75,0,4.98-2.23,4.98-4.98s-2.23-4.98-4.98-4.98H24.9C11.16,19.9.02,31.04,0,44.79v129.8c.02,13.75,11.16,24.89,24.9,24.9h139.76c13.75-.02,24.89-11.16,24.9-24.9v-44.23c0-2.75-2.23-4.98-4.98-4.98Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M193.44,12.91l-5.84-5.85c-8.75-8.75-22.95-8.75-31.7,0l-88.86,88.86c-.61.61-1.05,1.36-1.28,2.19l-11.69,42.19c-.48,1.73,0,3.58,1.28,4.85,1.27,1.27,3.12,1.76,4.85,1.28l42.19-11.69c.83-.23,1.58-.67,2.19-1.28l88.86-88.87c8.74-8.76,8.74-22.94,0-31.7ZM66.02,134.49l7.18-25.92,18.74,18.74-25.92,7.18ZM101.34,122.63l-23.45-23.46L150.62,26.44l23.45,23.46-72.73,72.73ZM186.4,37.57l-5.28,5.28-23.46-23.46,5.28-5.28c4.86-4.86,12.75-4.86,17.61,0l5.85,5.84c4.85,4.87,4.85,12.75,0,17.61Z"
  })));
};
export default SvgEdit01;